<template>
  <div
    data-testid="progress-bar-circular"
    class="spinner relative inline-block rounded-full border-4 border-primary-subtle"
    :class="{
      'h-6 w-6': size && size === 'small',
      'h-10 w-10': !size,
      'after:border-t-success': color === 'tailwind',
      'after:border-t-primary-solid': !color,
    }"
  ></div>
</template>

<script lang="ts" setup>
defineProps<{
  size?: 'small' | undefined
  color?: 'tailwind' | undefined
}>()
</script>

<style scoped>
@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.spinner::after {
  -webkit-animation: spin 1s linear infinite;
  animation: spin 1s linear infinite;
  content: '';
  border: 4px solid transparent;
  border-radius: var(--radius-2xl);
  position: absolute;
  top: -4px;
  right: -4px;
  bottom: -4px;
  left: -4px;
}
</style>
